import React from 'react'

import { Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  arrayOf, bool, node, number, oneOfType, shape, string,
} from 'prop-types'

import DataTable from 'Pods/Shared/DataTable/DataTable'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function RegularEarningsDetailTable({
  rows = EMPTY_ARRAY,
  columns,
  isLoading = false,
  emptyMessage = null,
}) {
  if (isLoading) {
    return (
      <div className="regular-earnings-detail-panel__table-wrapper">
        <div className="spinner-container">
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <div className="regular-earnings-detail-panel__table-wrapper">
      <DataTable
        data={rows}
        columns={columns}
        emptyMessage={emptyMessage}
      />
    </div>
  )
}

RegularEarningsDetailTable.propTypes = {
  rows: arrayOf(shape({
    id: oneOfType([string, number]),
  })),
  columns: arrayOf(shape({
    key: string.isRequired,
  })).isRequired,
  isLoading: bool,
  emptyMessage: node,
}

export default RegularEarningsDetailTable
